import { Nav } from './components/Nav';
import { Hero } from './components/Hero';

export function App(): JSX.Element {
  return (
    <>
      <Nav />
      <main>
        <Hero />
      </main>
    </>
  );
}
